import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './FeelingSelector.css';
import { FaTimes } from 'react-icons/fa';

// Liste des feelings disponibles
const FEELINGS = [
  { id: 'happy', label: 'heureux(se)', icon: '😊' },
  { id: 'blessed', label: 'reconnaissant(e)', icon: '🙏' },
  { id: 'loved', label: 'aimé(e)', icon: '❤️' },
  { id: 'sad', label: 'triste', icon: '😢' },
  { id: 'angry', label: 'en colère', icon: '😡' },
  { id: 'tired', label: 'fatigué(e)', icon: '😴' },
  { id: 'sick', label: 'malade', icon: '🤒' },
  { id: 'excited', label: 'enthousiaste', icon: '🤩' },
  { id: 'crazy', label: 'fou/folle', icon: '🤪' },
  { id: 'bored', label: 'ennuyé(e)', icon: '😒' },
  { id: 'confident', label: 'confiant(e)', icon: '😎' },
  { id: 'thoughtful', label: 'pensif(ve)', icon: '🤔' },
  { id: 'worried', label: 'inquiet(ète)', icon: '😟' },
  { id: 'determined', label: 'déterminé(e)', icon: '💪' },
  { id: 'thankful', label: 'reconnaissant(e)', icon: '🥰' },
];

const FeelingSelector = ({ 
  isVisible, 
  onClose, 
  onSelectFeeling 
}) => {
  if (!isVisible) return null;

  const handleFeelingSelect = (feeling) => {
    onSelectFeeling(feeling);
    onClose();
  };

  return (
    <div className="fs-container">
      <div className="fs-header">
        <span>Comment vous sentez-vous?</span>
        <div className="fs-close" onClick={onClose}>
          <FaTimes />
        </div>
      </div>
      <div className="fs-list">
        {FEELINGS.map((feeling) => (
          <div
            key={feeling.id}
            className="fs-option"
            onClick={() => handleFeelingSelect(feeling)}
          >
            <span className="fs-emoji">{feeling.icon}</span>
            <span className="fs-label">{feeling.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeelingSelector;
export {FeelingSelector};